import { useEffect, createContext } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import {
  Home,
  Users,
  BookOpen,
  Layers,
  Bell,
  Search,
  ShieldCheck,
  Flag,
  Briefcase,
  UserCheck,
  FileText,
  CreditCard,
  Receipt,
  Tag,
  User,
  Share2,
  ListChecks,
  FileCheck2,
  Wallet,
} from "lucide-react";
import DashboardLayout from "../dashboard/DashboardLayout";
import NavItem, { NavSection } from "../dashboard/components/navItem";
import ScrollToTop from "../../utils/scrollToTop";
import RoleSwitcher from "../../components/layout/RoleSwitcher";

const AdminDashboardLayout = () => {
  const location = useLocation();

  useEffect(() => {
    localStorage.setItem("from", location.pathname);
  }, [location.pathname]);

  const SidebarNav = (
    <>
      <NavItem to="/staff/dashboard" icon={Home} label="Overview" end />

      <NavSection label="Academic Operations" />
      <NavItem
        to="/staff/dashboard/users"
        icon={Users}
        label="User Management"
        end
      />
      <NavItem
        to="/staff/dashboard/courses"
        icon={BookOpen}
        label="Course Library"
        end
      />
      <NavItem
        to="/staff/dashboard/tracks"
        icon={Layers}
        label="Career Tracks"
        end
      />

      <NavSection label="Operations & Logistics" />
      <NavItem
        to="/staff/dashboard/staff-jobs"
        icon={Briefcase}
        label="Staff Assignments"
        end
      />
      <NavItem
        to="/staff/dashboard/visitors"
        icon={UserCheck}
        label="Visitor Log"
        end
      />
      <NavItem
        to="/staff/dashboard/price-list"
        icon={Tag}
        label="Company Price List"
        end
      />

      <NavSection label="Finance & Treasury" />
      <NavItem
        to="/staff/dashboard/payments"
        icon={CreditCard}
        label="Finance & Payouts"
        end
      />
      <NavItem
        to="/staff/dashboard/income-expenditure"
        icon={Receipt}
        label="Income & Expenditure"
        end
      />

      <NavSection label="Content & Communication" />
      <NavItem to="/staff/dashboard/reports" icon={Flag} label="Reports" end />
      <NavItem
        to="/staff/dashboard/blog"
        icon={FileText}
        label="Blog Management"
        end
      />
      <NavItem
        to="/staff/dashboard/social-broadcast"
        icon={Share2}
        label="Social Broadcast"
        end
      />
      <NavItem
        to="/staff/dashboard/notifications"
        icon={Bell}
        label="Notifications"
        end
      />

      <NavSection label="Verification Services" />
      <NavItem
        to="/staff/dashboard/verification"
        icon={ShieldCheck}
        label="Verification Center"
        end
      />
      <NavItem
        to="/staff/dashboard/verification/services"
        icon={ListChecks}
        label="Services Catalog"
        end
      />
      <NavItem
        to="/staff/dashboard/verification/logs"
        icon={FileCheck2}
        label="Verification Logs"
        end
      />
      <NavItem
        to="/staff/dashboard/verification/wallet"
        icon={Wallet}
        label="Verification Wallet"
        end
      />

      <NavSection label="Account & Preferences" />
      <NavItem
        to="/staff/dashboard/profile"
        icon={User}
        label="Profile & Settings"
        end
      />
    </>
  );

  const TopBarAddons = (
    <div className="cht-flex cht-items-center cht-gap-2">
      <RoleSwitcher />
      <div className="cht-hidden md:cht-flex cht-relative cht-mr-2 cht-group">
        <Search
          className="cht-absolute cht-left-3 cht-top-1/2 -cht-translate-y-1/2 cht-text-gray-400 group-focus-within:cht-text-[#3e57da] cht-transition-colors"
          size={16}
        />
        <input
          type="text"
          placeholder="Global search..."
          className="cht-w-40 lg:cht-w-64 cht-bg-white/50 cht-border cht-border-gray-200/50 cht-rounded-xl cht-py-2 cht-pl-9 cht-pr-4 cht-text-xs cht-font-medium cht-focus:ring-2 cht-focus:ring-[#3e57da]/10 cht-focus:border-[#3e57da] cht-outline-none cht-transition-all"
        />
      </div>

      <div className="cht-flex cht-items-center cht-gap-1 cht-px-3 cht-py-1.5 cht-bg-amber-50 cht-border cht-border-amber-100 cht-rounded-full cht-text-amber-700 cht-text-[10px] cht-font-black cht-uppercase">
        <ShieldCheck size={12} />
        Admin Mode
      </div>
    </div>
  );

  return (
    <>
      <ScrollToTop />
      <DashboardLayout
        sidebarNavContent={SidebarNav}
        topBarAddons={TopBarAddons}
      >
        <Outlet />
      </DashboardLayout>
    </>
  );
};

export default AdminDashboardLayout;
